import React, { useState } from 'react';
import ProductItemDropDown from './ProductItemDropDown';
import { v4 as uuidv4 } from 'uuid';
import { useSortable } from '@dnd-kit/sortable';
import { ProductThumb } from '../../../../Components/Product/ProductThumb';
import { Tooltip } from '../../../../Components/Tooltip/Tooltip';

const ProductCard = ({
	product,
	isDraggableItem = false,
	deleteItemFunction = () => { undefined; },
	idInClipBoard,
	copyToClipBoard,
	isReplace = {
		isATransformationReplace: false,
		oldProductId: '',
		replaceProductId: ''
	},
	isPinned = {
		pinned: false,
		productWithPosition: undefined
	},
	dimension,
	isRanking = true,
	inPromoteDemoteList = false,
	selectionCheckbox,
	deleteReplaceProductWithId,
	deletePinnedProductWithId
}) => {

	const idTooltip = uuidv4();
	const idTooltipPin = uuidv4();
	const idTooltipSwap = uuidv4();
	const { id, name, urlThumbnail, price, unitPriceWithRebate } = product;
	const [copySuccess, setCopySuccess] = useState(false);

	const {
		listeners,
	} = useSortable({ id: product.id });

	function handleCopy(id) {
		copyToClipBoard(id);
		setCopySuccess(true);
		setTimeout(() => {
			setCopySuccess(false);
		}, 3000);
	}

	function get_ordered_prices(price1, price2) {
		if (price1 == 0) {
			return [price2];
		}
		if (price2 == 0) {
			return [price1];
		}
		if (price1 == price2) {
			return [price1];
		}
		if (price2 > price1) {
			return [price1, price2];
		}
		return [price2, price1];
	}

	function format_price(p) {
		const currency = '€';
		return p.toFixed(2) + '\u00A0' + currency;
	}

	const prices = get_ordered_prices(price, unitPriceWithRebate);
	const newPrice = format_price(prices[0]);
	const oldPrice = prices[1] ? format_price(prices[1]) : null;
	const stockQte = product.globalStockQuantity !== null ? product.globalStockQuantity : undefined;

	const handleUnpin = () => {
		deletePinnedProductWithId(product.id);
	};

	const handleUnReplace = () => {
		deleteReplaceProductWithId(product.id);
	};

	return (
		<div className="collection_card">
			<Tooltip id={idTooltip} />
			<div className="collection_card_image_wrapper">
				<ProductThumb
					url={urlThumbnail}
					alt={name}
					hasMargin={false}
					hasShadow={true}
					width={'full'}
					ratio={.9}
					backgroundColor={'white'}
				/>
				<div className='collection_card_actions_wrapper'>
					{isDraggableItem &&
						<a className='collection_card_action'
							data-for={idTooltip}
							data-tip={'Drag to sort'}
							style={{cursor: 'grab'}}
							{...listeners}>
							<i className="fas fa-arrows-alt" />
						</a>
					}
					{isRanking && !inPromoteDemoteList &&
						<ProductItemDropDown
							isATransformationReplace={isReplace.isATransformationReplace}
							idProduct={id}
							idInClipBoard={idInClipBoard}
							isPinned={isPinned}
							product={product}
						/>
					}
				</div>
				<div className='collection_card_status_wrapper'>
					{dimension == 'promoted' &&
						<div className='collection_status' data-for={idTooltip} data-tip={'Promoted product. Click to reset.'}>
							<i className='fas fa-arrow-circle-up' />
							<button className='collection_status_remove' onClick={deleteItemFunction}>
								<i className='fas fa-times'></i>	
							</button>
						</div>
					}
					{dimension == 'demoted' &&
						<div className='collection_status' data-for={idTooltip} data-tip={'Demoted product. Click to reset.'}>
							<i className='fas fa-arrow-circle-down' />
							<button className='collection_status_remove' onClick={deleteItemFunction}>
								<i className='fas fa-times'></i>	
							</button>
						</div>
					}
					{isReplace.isATransformationReplace &&
						<>
							<Tooltip id={idTooltipSwap} />
							<div className='collection_status' data-for={idTooltipSwap} data-tip={`Swapped with product: ${isReplace.replaceProductId}. Click to reset.`}>
								<i className='fas fa-retweet'></i>
								<button className='collection_status_remove' onClick={handleUnReplace}>
									<i className='fas fa-times'></i>	
								</button>
							</div>
						</>
					}
					{isPinned.pinned && isPinned.productWithPosition !== undefined &&
						<>
							<Tooltip id={idTooltipPin} />
							<div className='collection_status' data-for={idTooltipPin} data-tip={`Product pinned at position: ${isPinned.productWithPosition.position + 1}. Click to reset.`}>
								<i className='fas fa-thumbtack pin-icon'></i>
								<button className='collection_status_remove' onClick={handleUnpin}>
									<i className='fas fa-times'></i>	
								</button>
							</div>
						</>
					}
				</div>
				{selectionCheckbox &&
					<div className='collection_card_selector'>
						{selectionCheckbox}
					</div>
				}
			</div>
			<div className='collection_card_info'>
				<div className="collection_card_name ellips" data-for={idTooltip} data-tip={name}>{name}</div>
				<div className="collection_card_price flex flex_wrap">
					<div className='flex_item_full'>
						{newPrice}
						{oldPrice &&
							<span className='collection_card_old_price'><s>{oldPrice}</s></span>
						}
					</div>
					{stockQte !== undefined &&
						<span className='flex_item_fix ml_10'>Stock : {stockQte}</span>
					}
				</div>
				<div className="collection_card_id">
					<a data-for={idTooltip}
						data-tip={'Copy id to clipboard'}
						onClick={() => handleCopy(id)}>
						{id}
						<span className='collection_card_hover'>
							{copySuccess ?
								<i className='fas fa-check'></i>
								:
								<i className='fas fa-copy'></i>
							}
						</span>
					</a>
				</div>
			</div>
		</div>
	);
};

export default ProductCard;